import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {

  constructor() { }

  public get imgSrc() {
    let src;
    if (localStorage.getItem("customStyles")) {
      const newCustomStyles = JSON.parse(localStorage.getItem("customStyles"));
      if (newCustomStyles.centralLogo?.src) {
        src = newCustomStyles.centralLogo.src;
      } else {
        src = 'assets/img/logo_gesvatec_transparent.png';
      }
    } else {
      src = 'assets/img/logo_gesvatec_transparent.png';
    }

    return src;
  }
}
